const template1DataConverter = ({ styleSettings, selectedNews, newsList }) => {
  return {
    openingSlide: {
      logo: styleSettings?.openingSlide?.logo?.url || "",
      backgroundColor: styleSettings?.openingSlide?.backgroundColor || "#fff",
    },
    slideItems: selectedNews.map((newsId) => {
      const news = newsList.find((news) => news.id === newsId);
      return {
        title: {
          text: news.title || "",
          font: styleSettings?.slideItem?.title?.font || "",
          color: styleSettings?.slideItem?.title?.color,
          backgroundColor: styleSettings?.slideItem?.title?.backgroundColor,
        },
        subTitle: {
          text: news.subTitle || "",
          font: styleSettings?.slideItem?.subTitle?.font || "",
          color: styleSettings?.slideItem?.subTitle?.color,
          backgroundColor: styleSettings?.slideItem?.subTitle?.backgroundColor,
        },
        category: {
          text: news.category || "",
          font: styleSettings?.slideItem?.category?.font || "",
          color: styleSettings?.slideItem?.category?.color || "",
          backgroundColor:
            styleSettings?.slideItem?.category?.backgroundColor || "",
        },
        voiceText: news.voiceText || "",
        imageUrl: news.image || "",
      };
    }),
  };
};

const TEMPLATE1_DEFAULT_STYLE_SETTINGS = {
  openingSlide: {
    logo: {
      url: "",
    },
    backgroundColor: "#ffffff",
  },
  slideItem: {
    title: {
      color: "#000000",
      font: "",
      backgroundColor: "#ffffff",
    },
    category: {
      color: "#000000",
      font: "",
      backgroundColor: "#ffffff",
    },
    subTitle: {
      color: "#000000",
      font: "",
      backgroundColor: "#ffffff",
    },
  },
};

export { template1DataConverter, TEMPLATE1_DEFAULT_STYLE_SETTINGS };
